













import { Component, Vue, Prop } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get href() {
    return window.location.href;
  }
  private goRoute(item: any) {
    this.$store.commit("updateResourceTab", "");
    clearFilter();
    this.$router.push(item.path);
  }
}
